import { cn } from "@/lib/utils";
import type { ShockwaveDetailViewT } from "@/types/database/events";
import { Activity, Cable, ChevronRight, Crosshair, Zap } from "lucide-react";
import { warningColors } from "../../../utils/warningColors";
import IconDetail from "../../../components/common/IconDetail";

interface Props {
    shockwaveDetails: ShockwaveDetailViewT[];
}

const ShockwaveDetailsList = ({ shockwaveDetails }: Props) => {
    if (!shockwaveDetails || shockwaveDetails.length === 0) {
        return (
            <p className="text-slate-500 text-sm">
                No shockwave details provided.
            </p>
        );
    }

    return (
        <div className="space-y-4">
            {shockwaveDetails.map((sdv) => (
                <div
                    key={sdv.shockwave_detail_id}
                    className={cn(
                        "flex flex-col gap-y-1 text-sm text-slate-800 dark:text-slate-300",
                    )}
                >
                    <span className="flex justify-start items-center gap-2">
                        <Activity size={20} />
                        {sdv.side || (
                            <span className={cn(warningColors(true))}>
                                Side not specified
                            </span>
                        )}
                    </span>
                    <span className="flex flex-wrap justify-start items-center gap-1 text-nowrap">
                        <Crosshair size={20} />
                        {sdv.orthopaedic_area || (
                            <span className={cn(warningColors(true))}>
                                Area not specified
                            </span>
                        )}
                        {(sdv.site || sdv.subsite) && (
                            <>
                                <ChevronRight size={16} />
                                {sdv.site || (
                                    <span className={cn(warningColors(true))}>
                                        Site not specified
                                    </span>
                                )}
                                {sdv.subsite && (
                                    <>
                                        <ChevronRight size={16} />
                                        {sdv.subsite}
                                    </>
                                )}
                            </>
                        )}
                    </span>
                    <IconDetail
                        icon={<Zap size={16} />}
                        words={sdv.impulses
                            ? (
                                <>
                                    {sdv.impulses} impulses
                                </>
                            )
                            : (
                                <span className={cn(warningColors(true))}>
                                    Impulses not specified
                                </span>
                            )}
                    />
                    <IconDetail
                        icon={<Cable size={16} />}
                        words={sdv.dose && sdv.unit &&
                            `${sdv.dose} ${sdv.unit}`}
                    />
                </div>
            ))}
        </div>
    );
};

export default ShockwaveDetailsList;
